// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2y2CV","modalForm":"UpgradeEpcsModal_modalForm__2fSMc","modalFooter":"UpgradeEpcsModal_modalFooter__3eHht"};